import React from 'react'
import dynamic from 'next/dynamic'

import { useBucket } from '@mc/experiments-react'

import { SealedBucketTrailerModalControl } from './SealedBucketTrailerModalControl'
import { type SealedBucketTrailerModalVariantProps } from '../types'
import { QR_SEALED_BUCKET_V1_EXP_NAME } from '../utils'
import { LESSONS_ON_QR_EXP_NAME } from '../../pen-4824_v1-qr-sealed-bucket-with-lessons'

const SealedBucketTrailerModalVariant1 = dynamic(
  () =>
    import(
      /* webpackChunkName: 'pen-44743_v1-variant_1' */ './SealedBucketTrailerModalVariant1'
    ).then((mod) => mod.SealedBucketTrailerModalVariant1),
  { ssr: false },
)

type SealedBucketTrailerModalExperimentProps = {
  control: React.ReactNode
} & SealedBucketTrailerModalVariantProps

export const SealedBucketTrailerModalExperiment = ({
  control,
  ...videoModalProps
}: SealedBucketTrailerModalExperimentProps) => {
  const sealedBucketV1Bucket = useBucket(QR_SEALED_BUCKET_V1_EXP_NAME)
  const lessonsOnQRBucket = useBucket(LESSONS_ON_QR_EXP_NAME)

  if (
    sealedBucketV1Bucket === 'variant_2' ||
    lessonsOnQRBucket?.startsWith('variant')
  ) {
    return <SealedBucketTrailerModalVariant1 {...videoModalProps} />
  }

  return (
    <SealedBucketTrailerModalControl
      control={control}
      courseSlug={videoModalProps.course?.slug || videoModalProps.courseSlug}
    />
  )
}
